module.exports = __webpack_public_path__ + "static/media/oh_pack2_sample010_0001.7994fb6f.png";